import { MOTION } from '@kpv-lab/common/motion'

// How long the pointer rests on an element before its tooltip appears.
export const TOOLTIP_DELAY_MS = MOTION.hoverDelay

// The opacity transition in Tooltip.css.
export const FADE_MS = MOTION.medium
